import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { GithubTable } from 'components/Tables/GithubTable';
import { useLocation } from 'react-router-dom';

const Github: FC = observer(() => {
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    if (token) {
      localStorage.setItem('token', `Bearer ${token}`);
    }
  }, [location.search]);

  return (
    <>
      <GithubTable />
    </>
  );
});

export default Github;
